const routers = [
  {
    // 送货单
    path: '/delivery/list',
    name: 'delivery',
    component: () => import('@/views/modules/delivery/List.vue')
  }
]
export default routers
